/* tslint:disable */
/* eslint-disable */

// @ts-ignore
import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// @ts-ignore
import type { ConfigurationParameters } from '../configuration';
// @ts-ignore
import { Configuration as OpenApiGeneratorConfiguration } from '../configuration';
// @ts-ignore
import type { AxiosError, AxiosResponse } from 'axios';
import {
    useQuery,
    UseMutationOptions,
    useMutation,
    UseQueryOptions
    // @ts-ignore
} from 'react-query';
// @ts-ignore
import { useAuthorizationToken, useAuthQueryKey, useApiBasePath } from '../../utils';
// Some imports not used depending on template conditions
// @ts-ignore
import {
    DUMMY_BASE_URL,
    assertParamExists,
    setApiKeyToObject,
    setBasicAuthToObject,
    setBearerAuthToObject,
    setOAuthToObject,
    setSearchParams,
    serializeDataIfNeeded,
    toPathString,
    createRequestFunction
} from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Resource } from '../models';
// @ts-ignore
import { ResourceType } from '../models';
/**
 * ResourceWebServicesApi - axios parameter creator
 * @export
 */
export const ResourceWebServicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {Resource} resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResource: async (resource: Resource, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resource' is not null or undefined
            assertParamExists('createResource', 'resource', resource);
            const localVarPath = `/resource`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = serializeDataIfNeeded(resource, localVarRequestOptions, configuration);

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {ResourceType} type
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResource: async (
            type: ResourceType,
            name: string,
            options: AxiosRequestConfig = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('deleteResource', 'type', type);
            // verify required parameter 'name' is not null or undefined
            assertParamExists('deleteResource', 'name', name);
            const localVarPath = `/resource/{type}/{name}`
                .replace(`{${'type'}}`, encodeURIComponent(String(type)))
                .replace(`{${'name'}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {Array<Resource>} resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResources: async (resource: Array<Resource>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resource' is not null or undefined
            assertParamExists('deleteResources', 'resource', resource);
            const localVarPath = `/resources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = serializeDataIfNeeded(resource, localVarRequestOptions, configuration);

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {ResourceType} type
         * @param {string} name
         * @param {boolean} [includeNonActive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResource: async (
            type: ResourceType,
            name: string,
            includeNonActive?: boolean,
            options: AxiosRequestConfig = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getResource', 'type', type);
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getResource', 'name', name);
            const localVarPath = `/resource/{type}/{name}`
                .replace(`{${'type'}}`, encodeURIComponent(String(type)))
                .replace(`{${'name'}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            if (includeNonActive !== undefined) {
                localVarQueryParameter['includeNonActive'] = includeNonActive;
            }

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {boolean} [includeNonActive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResources: async (includeNonActive?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/resource`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            if (includeNonActive !== undefined) {
                localVarQueryParameter['includeNonActive'] = includeNonActive;
            }

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {ResourceType} type
         * @param {boolean} [includeNonActive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourcesByType: async (
            type: ResourceType,
            includeNonActive?: boolean,
            options: AxiosRequestConfig = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getResourcesByType', 'type', type);
            const localVarPath = `/resource/{type}`.replace(`{${'type'}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            if (includeNonActive !== undefined) {
                localVarQueryParameter['includeNonActive'] = includeNonActive;
            }

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {Array<Resource>} resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setResources: async (resource: Array<Resource>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resource' is not null or undefined
            assertParamExists('setResources', 'resource', resource);
            const localVarPath = `/resources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = serializeDataIfNeeded(resource, localVarRequestOptions, configuration);

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {Resource} resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateResource: async (resource: Resource, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resource' is not null or undefined
            assertParamExists('updateResource', 'resource', resource);
            const localVarPath = `/resource`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = serializeDataIfNeeded(resource, localVarRequestOptions, configuration);

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};

/**
 * ResourceWebServicesApi - functional programming interface
 * @export
 */
export const ResourceWebServicesApiFp = function (configuration?: Configuration) {
    const localVarAxiosParamCreator = ResourceWebServicesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {Resource} resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createResource(
            resource: Resource,
            options?: AxiosRequestConfig
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Resource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createResource(resource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        },
        /**
         *
         * @param {ResourceType} type
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteResource(
            type: ResourceType,
            name: string,
            options?: AxiosRequestConfig
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteResource(type, name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        },
        /**
         *
         * @param {Array<Resource>} resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteResources(
            resource: Array<Resource>,
            options?: AxiosRequestConfig
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteResources(resource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        },
        /**
         *
         * @param {ResourceType} type
         * @param {string} name
         * @param {boolean} [includeNonActive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResource(
            type: ResourceType,
            name: string,
            includeNonActive?: boolean,
            options?: AxiosRequestConfig
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Resource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResource(
                type,
                name,
                includeNonActive,
                options
            );
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        },
        /**
         *
         * @param {boolean} [includeNonActive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResources(
            includeNonActive?: boolean,
            options?: AxiosRequestConfig
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Resource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResources(includeNonActive, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        },
        /**
         *
         * @param {ResourceType} type
         * @param {boolean} [includeNonActive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResourcesByType(
            type: ResourceType,
            includeNonActive?: boolean,
            options?: AxiosRequestConfig
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Resource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResourcesByType(
                type,
                includeNonActive,
                options
            );
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        },
        /**
         *
         * @param {Array<Resource>} resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setResources(
            resource: Array<Resource>,
            options?: AxiosRequestConfig
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Resource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setResources(resource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        },
        /**
         *
         * @param {Resource} resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateResource(
            resource: Resource,
            options?: AxiosRequestConfig
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Resource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateResource(resource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        }
    };
};

/**
 * ResourceWebServicesApi - factory interface
 * @export
 */
export const ResourceWebServicesApiFactory = function (
    configuration?: Configuration,
    basePath?: string,
    axios?: AxiosInstance
) {
    const localVarFp = ResourceWebServicesApiFp(configuration);
    return {
        /**
         *
         * @param {ResourceWebServicesApiCreateResourceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResource(
            requestParameters: ResourceWebServicesApiCreateResourceRequest,
            options?: AxiosRequestConfig
        ): AxiosPromise<Resource> {
            return localVarFp
                .createResource(requestParameters.resource, options)
                .then(request => request(axios, basePath));
        },
        /**
         *
         * @param {ResourceWebServicesApiDeleteResourceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResource(
            requestParameters: ResourceWebServicesApiDeleteResourceRequest,
            options?: AxiosRequestConfig
        ): AxiosPromise<void> {
            return localVarFp
                .deleteResource(requestParameters.type, requestParameters.name, options)
                .then(request => request(axios, basePath));
        },
        /**
         *
         * @param {ResourceWebServicesApiDeleteResourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResources(
            requestParameters: ResourceWebServicesApiDeleteResourcesRequest,
            options?: AxiosRequestConfig
        ): AxiosPromise<void> {
            return localVarFp
                .deleteResources(requestParameters.resource, options)
                .then(request => request(axios, basePath));
        },
        /**
         *
         * @param {ResourceWebServicesApiGetResourceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResource(
            requestParameters: ResourceWebServicesApiGetResourceRequest,
            options?: AxiosRequestConfig
        ): AxiosPromise<Resource> {
            return localVarFp
                .getResource(
                    requestParameters.type,
                    requestParameters.name,
                    requestParameters.includeNonActive,
                    options
                )
                .then(request => request(axios, basePath));
        },
        /**
         *
         * @param {ResourceWebServicesApiGetResourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResources(
            requestParameters: ResourceWebServicesApiGetResourcesRequest = {},
            options?: AxiosRequestConfig
        ): AxiosPromise<Array<Resource>> {
            return localVarFp
                .getResources(requestParameters.includeNonActive, options)
                .then(request => request(axios, basePath));
        },
        /**
         *
         * @param {ResourceWebServicesApiGetResourcesByTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourcesByType(
            requestParameters: ResourceWebServicesApiGetResourcesByTypeRequest,
            options?: AxiosRequestConfig
        ): AxiosPromise<Array<Resource>> {
            return localVarFp
                .getResourcesByType(requestParameters.type, requestParameters.includeNonActive, options)
                .then(request => request(axios, basePath));
        },
        /**
         *
         * @param {ResourceWebServicesApiSetResourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setResources(
            requestParameters: ResourceWebServicesApiSetResourcesRequest,
            options?: AxiosRequestConfig
        ): AxiosPromise<Array<Resource>> {
            return localVarFp
                .setResources(requestParameters.resource, options)
                .then(request => request(axios, basePath));
        },
        /**
         *
         * @param {ResourceWebServicesApiUpdateResourceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateResource(
            requestParameters: ResourceWebServicesApiUpdateResourceRequest,
            options?: AxiosRequestConfig
        ): AxiosPromise<Resource> {
            return localVarFp
                .updateResource(requestParameters.resource, options)
                .then(request => request(axios, basePath));
        }
    };
};

/**
 * Request parameters for createResource operation in ResourceWebServicesApi.
 * @export
 * @interface ResourceWebServicesApiCreateResourceRequest
 */
export interface ResourceWebServicesApiCreateResourceRequest {
    /**
     *
     * @type {Resource}
     * @memberof ResourceWebServicesApiCreateResource
     */
    readonly resource: Resource;
}

/**
 * Request parameters for deleteResource operation in ResourceWebServicesApi.
 * @export
 * @interface ResourceWebServicesApiDeleteResourceRequest
 */
export interface ResourceWebServicesApiDeleteResourceRequest {
    /**
     *
     * @type {ResourceType}
     * @memberof ResourceWebServicesApiDeleteResource
     */
    readonly type: ResourceType;

    /**
     *
     * @type {string}
     * @memberof ResourceWebServicesApiDeleteResource
     */
    readonly name: string;
}

/**
 * Request parameters for deleteResources operation in ResourceWebServicesApi.
 * @export
 * @interface ResourceWebServicesApiDeleteResourcesRequest
 */
export interface ResourceWebServicesApiDeleteResourcesRequest {
    /**
     *
     * @type {Array<Resource>}
     * @memberof ResourceWebServicesApiDeleteResources
     */
    readonly resource: Array<Resource>;
}

/**
 * Request parameters for getResource operation in ResourceWebServicesApi.
 * @export
 * @interface ResourceWebServicesApiGetResourceRequest
 */
export interface ResourceWebServicesApiGetResourceRequest {
    /**
     *
     * @type {ResourceType}
     * @memberof ResourceWebServicesApiGetResource
     */
    readonly type: ResourceType;

    /**
     *
     * @type {string}
     * @memberof ResourceWebServicesApiGetResource
     */
    readonly name: string;

    /**
     *
     * @type {boolean}
     * @memberof ResourceWebServicesApiGetResource
     */
    readonly includeNonActive?: boolean;
}

/**
 * Request parameters for getResources operation in ResourceWebServicesApi.
 * @export
 * @interface ResourceWebServicesApiGetResourcesRequest
 */
export interface ResourceWebServicesApiGetResourcesRequest {
    /**
     *
     * @type {boolean}
     * @memberof ResourceWebServicesApiGetResources
     */
    readonly includeNonActive?: boolean;
}

/**
 * Request parameters for getResourcesByType operation in ResourceWebServicesApi.
 * @export
 * @interface ResourceWebServicesApiGetResourcesByTypeRequest
 */
export interface ResourceWebServicesApiGetResourcesByTypeRequest {
    /**
     *
     * @type {ResourceType}
     * @memberof ResourceWebServicesApiGetResourcesByType
     */
    readonly type: ResourceType;

    /**
     *
     * @type {boolean}
     * @memberof ResourceWebServicesApiGetResourcesByType
     */
    readonly includeNonActive?: boolean;
}

/**
 * Request parameters for setResources operation in ResourceWebServicesApi.
 * @export
 * @interface ResourceWebServicesApiSetResourcesRequest
 */
export interface ResourceWebServicesApiSetResourcesRequest {
    /**
     *
     * @type {Array<Resource>}
     * @memberof ResourceWebServicesApiSetResources
     */
    readonly resource: Array<Resource>;
}

/**
 * Request parameters for updateResource operation in ResourceWebServicesApi.
 * @export
 * @interface ResourceWebServicesApiUpdateResourceRequest
 */
export interface ResourceWebServicesApiUpdateResourceRequest {
    /**
     *
     * @type {Resource}
     * @memberof ResourceWebServicesApiUpdateResource
     */
    readonly resource: Resource;
}

/**
 * ResourceWebServicesApi - object-oriented interface
 * @export
 * @class ResourceWebServicesApi
 * @extends {BaseAPI}
 */
export class ResourceWebServicesApi extends BaseAPI {
    /**
     *
     * @param {ResourceWebServicesApiCreateResourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceWebServicesApi
     */
    public createResource(
        requestParameters: ResourceWebServicesApiCreateResourceRequest,
        options?: AxiosRequestConfig
    ) {
        return ResourceWebServicesApiFp(this.configuration)
            .createResource(requestParameters.resource, options)
            .then(request => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {ResourceWebServicesApiDeleteResourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceWebServicesApi
     */
    public deleteResource(
        requestParameters: ResourceWebServicesApiDeleteResourceRequest,
        options?: AxiosRequestConfig
    ) {
        return ResourceWebServicesApiFp(this.configuration)
            .deleteResource(requestParameters.type, requestParameters.name, options)
            .then(request => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {ResourceWebServicesApiDeleteResourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceWebServicesApi
     */
    public deleteResources(
        requestParameters: ResourceWebServicesApiDeleteResourcesRequest,
        options?: AxiosRequestConfig
    ) {
        return ResourceWebServicesApiFp(this.configuration)
            .deleteResources(requestParameters.resource, options)
            .then(request => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {ResourceWebServicesApiGetResourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceWebServicesApi
     */
    public getResource(requestParameters: ResourceWebServicesApiGetResourceRequest, options?: AxiosRequestConfig) {
        return ResourceWebServicesApiFp(this.configuration)
            .getResource(requestParameters.type, requestParameters.name, requestParameters.includeNonActive, options)
            .then(request => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {ResourceWebServicesApiGetResourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceWebServicesApi
     */
    public getResources(
        requestParameters: ResourceWebServicesApiGetResourcesRequest = {},
        options?: AxiosRequestConfig
    ) {
        return ResourceWebServicesApiFp(this.configuration)
            .getResources(requestParameters.includeNonActive, options)
            .then(request => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {ResourceWebServicesApiGetResourcesByTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceWebServicesApi
     */
    public getResourcesByType(
        requestParameters: ResourceWebServicesApiGetResourcesByTypeRequest,
        options?: AxiosRequestConfig
    ) {
        return ResourceWebServicesApiFp(this.configuration)
            .getResourcesByType(requestParameters.type, requestParameters.includeNonActive, options)
            .then(request => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {ResourceWebServicesApiSetResourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceWebServicesApi
     */
    public setResources(requestParameters: ResourceWebServicesApiSetResourcesRequest, options?: AxiosRequestConfig) {
        return ResourceWebServicesApiFp(this.configuration)
            .setResources(requestParameters.resource, options)
            .then(request => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {ResourceWebServicesApiUpdateResourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceWebServicesApi
     */
    public updateResource(
        requestParameters: ResourceWebServicesApiUpdateResourceRequest,
        options?: AxiosRequestConfig
    ) {
        return ResourceWebServicesApiFp(this.configuration)
            .updateResource(requestParameters.resource, options)
            .then(request => request(this.axios, this.basePath));
    }
}

// custom hook generation here
export type PostCreateResourceResponse = AxiosResponse<Resource>;
export const KeyPostCreateResource = 'PostCreateResource';
export const useMutationPostCreateResource = (
    options?: UseMutationOptions<PostCreateResourceResponse, AxiosError, ResourceWebServicesApiCreateResourceRequest>,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<PostCreateResourceResponse, AxiosError, ResourceWebServicesApiCreateResourceRequest>(
        (args: ResourceWebServicesApiCreateResourceRequest) =>
            new ResourceWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).createResource(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryPostCreateResource = (
    args: ResourceWebServicesApiCreateResourceRequest,
    options?: UseQueryOptions<PostCreateResourceResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<PostCreateResourceResponse, AxiosError>(
        [KeyPostCreateResource, args, options && options.queryKey, authQueryKey],
        () =>
            new ResourceWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).createResource(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export type DeleteDeleteResourceResponse = AxiosResponse<void>;
export const KeyDeleteDeleteResource = 'DeleteDeleteResource';
export const useMutationDeleteDeleteResource = (
    options?: UseMutationOptions<DeleteDeleteResourceResponse, AxiosError, ResourceWebServicesApiDeleteResourceRequest>,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<DeleteDeleteResourceResponse, AxiosError, ResourceWebServicesApiDeleteResourceRequest>(
        (args: ResourceWebServicesApiDeleteResourceRequest) =>
            new ResourceWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).deleteResource(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryDeleteDeleteResource = (
    args: ResourceWebServicesApiDeleteResourceRequest,
    options?: UseQueryOptions<DeleteDeleteResourceResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<DeleteDeleteResourceResponse, AxiosError>(
        [KeyDeleteDeleteResource, args, options && options.queryKey, authQueryKey],
        () =>
            new ResourceWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).deleteResource(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export type DeleteDeleteResourcesResponse = AxiosResponse<void>;
export const KeyDeleteDeleteResources = 'DeleteDeleteResources';
export const useMutationDeleteDeleteResources = (
    options?: UseMutationOptions<
        DeleteDeleteResourcesResponse,
        AxiosError,
        ResourceWebServicesApiDeleteResourcesRequest
    >,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<DeleteDeleteResourcesResponse, AxiosError, ResourceWebServicesApiDeleteResourcesRequest>(
        (args: ResourceWebServicesApiDeleteResourcesRequest) =>
            new ResourceWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).deleteResources(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryDeleteDeleteResources = (
    args: ResourceWebServicesApiDeleteResourcesRequest,
    options?: UseQueryOptions<DeleteDeleteResourcesResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<DeleteDeleteResourcesResponse, AxiosError>(
        [KeyDeleteDeleteResources, args, options && options.queryKey, authQueryKey],
        () =>
            new ResourceWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).deleteResources(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export type GetGetResourceResponse = AxiosResponse<Resource>;
export const KeyGetGetResource = 'GetGetResource';
export const useMutationGetGetResource = (
    options?: UseMutationOptions<GetGetResourceResponse, AxiosError, ResourceWebServicesApiGetResourceRequest>,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<GetGetResourceResponse, AxiosError, ResourceWebServicesApiGetResourceRequest>(
        (args: ResourceWebServicesApiGetResourceRequest) =>
            new ResourceWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).getResource(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryGetGetResource = (
    args: ResourceWebServicesApiGetResourceRequest,
    options?: UseQueryOptions<GetGetResourceResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<GetGetResourceResponse, AxiosError>(
        [KeyGetGetResource, args, options && options.queryKey, authQueryKey],
        () =>
            new ResourceWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).getResource(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export type GetGetResourcesResponse = AxiosResponse<Array<Resource>>;
export const KeyGetGetResources = 'GetGetResources';
export const useMutationGetGetResources = (
    options?: UseMutationOptions<GetGetResourcesResponse, AxiosError, ResourceWebServicesApiGetResourcesRequest>,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<GetGetResourcesResponse, AxiosError, ResourceWebServicesApiGetResourcesRequest>(
        (args: ResourceWebServicesApiGetResourcesRequest) =>
            new ResourceWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).getResources(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryGetGetResources = (
    args: ResourceWebServicesApiGetResourcesRequest,
    options?: UseQueryOptions<GetGetResourcesResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<GetGetResourcesResponse, AxiosError>(
        [KeyGetGetResources, args, options && options.queryKey, authQueryKey],
        () =>
            new ResourceWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).getResources(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export type GetGetResourcesByTypeResponse = AxiosResponse<Array<Resource>>;
export const KeyGetGetResourcesByType = 'GetGetResourcesByType';
export const useMutationGetGetResourcesByType = (
    options?: UseMutationOptions<
        GetGetResourcesByTypeResponse,
        AxiosError,
        ResourceWebServicesApiGetResourcesByTypeRequest
    >,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<GetGetResourcesByTypeResponse, AxiosError, ResourceWebServicesApiGetResourcesByTypeRequest>(
        (args: ResourceWebServicesApiGetResourcesByTypeRequest) =>
            new ResourceWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).getResourcesByType(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryGetGetResourcesByType = (
    args: ResourceWebServicesApiGetResourcesByTypeRequest,
    options?: UseQueryOptions<GetGetResourcesByTypeResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<GetGetResourcesByTypeResponse, AxiosError>(
        [KeyGetGetResourcesByType, args, options && options.queryKey, authQueryKey],
        () =>
            new ResourceWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).getResourcesByType(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export type PutSetResourcesResponse = AxiosResponse<Array<Resource>>;
export const KeyPutSetResources = 'PutSetResources';
export const useMutationPutSetResources = (
    options?: UseMutationOptions<PutSetResourcesResponse, AxiosError, ResourceWebServicesApiSetResourcesRequest>,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<PutSetResourcesResponse, AxiosError, ResourceWebServicesApiSetResourcesRequest>(
        (args: ResourceWebServicesApiSetResourcesRequest) =>
            new ResourceWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).setResources(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryPutSetResources = (
    args: ResourceWebServicesApiSetResourcesRequest,
    options?: UseQueryOptions<PutSetResourcesResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<PutSetResourcesResponse, AxiosError>(
        [KeyPutSetResources, args, options && options.queryKey, authQueryKey],
        () =>
            new ResourceWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).setResources(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export type PutUpdateResourceResponse = AxiosResponse<Resource>;
export const KeyPutUpdateResource = 'PutUpdateResource';
export const useMutationPutUpdateResource = (
    options?: UseMutationOptions<PutUpdateResourceResponse, AxiosError, ResourceWebServicesApiUpdateResourceRequest>,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<PutUpdateResourceResponse, AxiosError, ResourceWebServicesApiUpdateResourceRequest>(
        (args: ResourceWebServicesApiUpdateResourceRequest) =>
            new ResourceWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).updateResource(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryPutUpdateResource = (
    args: ResourceWebServicesApiUpdateResourceRequest,
    options?: UseQueryOptions<PutUpdateResourceResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<PutUpdateResourceResponse, AxiosError>(
        [KeyPutUpdateResource, args, options && options.queryKey, authQueryKey],
        () =>
            new ResourceWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).updateResource(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
